import { api } from "@/APIRequests";
import type { BaseItem, GroupedItem } from "@/core/types";

export async function getReasoningOptions(): Promise<GroupedItem<BaseItem>[]> {
  return api.acuityTyped.get_reasoning_options({ params: { showLoader: false } });
}
